import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ReportDetailDataFragment = {
  __typename?: 'Report';
  id: any;
  title: string;
  content?: string | null;
  createdAt: any;
  updatedAt: any;
};

export type ReportQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type ReportQuery = {
  __typename?: 'Query';
  adminReport: {
    __typename?: 'Report';
    id: any;
    title: string;
    content?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type EditReportMutationVariables = Types.Exact<{
  input: Types.UpdateReportInput;
  id: Types.Scalars['UUID'];
}>;

export type EditReportMutation = {
  __typename?: 'Mutation';
  adminEditReport: {
    __typename?: 'Report';
    id: any;
    title: string;
    content?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type CreateReportMutationVariables = Types.Exact<{
  input: Types.CreateReportInput;
}>;

export type CreateReportMutation = {
  __typename?: 'Mutation';
  adminCreateReport: {
    __typename?: 'Report';
    id: any;
    title: string;
    content?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteReportMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type DeleteReportMutation = {
  __typename?: 'Mutation';
  adminDeleteReport: {
    __typename?: 'Report';
    id: any;
    title: string;
    content?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export const ReportDetailDataFragmentDoc = gql`
  fragment ReportDetailData on Report {
    id
    title
    content
    createdAt
    updatedAt
  }
`;
export const ReportDocument = gql`
  query report($id: UUID!) {
    adminReport(id: $id) {
      ...ReportDetailData
    }
  }
  ${ReportDetailDataFragmentDoc}
`;
export type ReportComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ReportQuery,
    ReportQueryVariables
  >,
  'query'
> &
  ({ variables: ReportQueryVariables; skip?: boolean } | { skip: boolean });

export const ReportComponent = (props: ReportComponentProps) => (
  <ApolloReactComponents.Query<ReportQuery, ReportQueryVariables>
    query={ReportDocument}
    {...props}
  />
);

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(
  baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportQuery, ReportQueryVariables>(
    ReportDocument,
    options,
  );
}
export function useReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(
    ReportDocument,
    options,
  );
}
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportQueryResult = Apollo.QueryResult<
  ReportQuery,
  ReportQueryVariables
>;
export const EditReportDocument = gql`
  mutation editReport($input: UpdateReportInput!, $id: UUID!) {
    adminEditReport(input: $input, id: $id) {
      ...ReportDetailData
    }
  }
  ${ReportDetailDataFragmentDoc}
`;
export type EditReportMutationFn = Apollo.MutationFunction<
  EditReportMutation,
  EditReportMutationVariables
>;
export type EditReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    EditReportMutation,
    EditReportMutationVariables
  >,
  'mutation'
>;

export const EditReportComponent = (props: EditReportComponentProps) => (
  <ApolloReactComponents.Mutation<
    EditReportMutation,
    EditReportMutationVariables
  >
    mutation={EditReportDocument}
    {...props}
  />
);

/**
 * __useEditReportMutation__
 *
 * To run a mutation, you first call `useEditReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReportMutation, { data, loading, error }] = useEditReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditReportMutation,
    EditReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditReportMutation, EditReportMutationVariables>(
    EditReportDocument,
    options,
  );
}
export type EditReportMutationHookResult = ReturnType<
  typeof useEditReportMutation
>;
export type EditReportMutationResult =
  Apollo.MutationResult<EditReportMutation>;
export type EditReportMutationOptions = Apollo.BaseMutationOptions<
  EditReportMutation,
  EditReportMutationVariables
>;
export const CreateReportDocument = gql`
  mutation createReport($input: CreateReportInput!) {
    adminCreateReport(input: $input) {
      ...ReportDetailData
    }
  }
  ${ReportDetailDataFragmentDoc}
`;
export type CreateReportMutationFn = Apollo.MutationFunction<
  CreateReportMutation,
  CreateReportMutationVariables
>;
export type CreateReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateReportMutation,
    CreateReportMutationVariables
  >,
  'mutation'
>;

export const CreateReportComponent = (props: CreateReportComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateReportMutation,
    CreateReportMutationVariables
  >
    mutation={CreateReportDocument}
    {...props}
  />
);

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReportMutation,
    CreateReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReportMutation,
    CreateReportMutationVariables
  >(CreateReportDocument, options);
}
export type CreateReportMutationHookResult = ReturnType<
  typeof useCreateReportMutation
>;
export type CreateReportMutationResult =
  Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<
  CreateReportMutation,
  CreateReportMutationVariables
>;
export const DeleteReportDocument = gql`
  mutation deleteReport($id: UUID!) {
    adminDeleteReport(id: $id) {
      ...ReportDetailData
    }
  }
  ${ReportDetailDataFragmentDoc}
`;
export type DeleteReportMutationFn = Apollo.MutationFunction<
  DeleteReportMutation,
  DeleteReportMutationVariables
>;
export type DeleteReportComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >,
  'mutation'
>;

export const DeleteReportComponent = (props: DeleteReportComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >
    mutation={DeleteReportDocument}
    {...props}
  />
);

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReportMutation,
    DeleteReportMutationVariables
  >(DeleteReportDocument, options);
}
export type DeleteReportMutationHookResult = ReturnType<
  typeof useDeleteReportMutation
>;
export type DeleteReportMutationResult =
  Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteReportMutation,
  DeleteReportMutationVariables
>;
